import { useMemo } from 'react';
import { useDateService } from 'framework/utils';
import { Badge } from 'framework/ui/mui-builder';
import { FieldProps, useFieldHelper } from 'framework/ui/field';

interface FieldBadgeProps extends FieldProps {
  endDateSource: string;
}

const AssignmentDurationBadge = ({ endDateSource }: FieldBadgeProps) => {
  const { getValue: getEndDate } = useFieldHelper({ source: endDateSource });
  const { getDaysBetween, getMonthsBetween, getCurrentDateTimeInUtc } = useDateService();
  const now = getCurrentDateTimeInUtc();

  const badgeData = useMemo(() => {
    if (!getEndDate()) {
      return null;
    }

    const daysRemaining = getDaysBetween(getEndDate(), now);
    const isWarning = daysRemaining < 14;
    const monthsRemaining = getMonthsBetween(getEndDate(), now);

    let formattedTime;
    if (monthsRemaining! >= 12) {
      const years = Math.floor(monthsRemaining! / 12);
      formattedTime = `${years}y`;
    } else if (monthsRemaining! >= 1) {
      formattedTime = `${Math.floor(monthsRemaining!)}m`;
    } else {
      formattedTime = `${daysRemaining}d`;
    }

    return {
      formattedTime,
      isWarning,
    };
  }, [getEndDate, now, getDaysBetween, getMonthsBetween]);

  if (!getEndDate() || !badgeData) {
    return null;
  }

  return <Badge color={badgeData.isWarning ? 'error' : 'default'}>{badgeData.formattedTime}</Badge>;
};

export default AssignmentDurationBadge;
